"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _modalDecorator = _interopRequireDefault(require("../../../../hocs/modalDecorator"));
var _modalActions = require("../../../../redux/actions/modalActions");
var _BuySellConfirmationModalComponent = _interopRequireDefault(require("./BuySellConfirmationModalComponent"));
var _buySellSelectors = require("../../../../redux/selectors/buySellSelectors");
var _snackbarActions = require("../../../../redux/actions/snackbarActions");
var _orderEntryActions = require("../../../../redux/actions/orderEntryActions");
var _orderFormTypes = require("../../../../constants/sendOrder/orderFormTypes");
var _orderHelper = require("../../../../helpers/orderHelper.js");
var _numberFormatter = require("../../../../helpers/numberFormatter");
var _instrumentPositionSelectors = require("../../../../redux/selectors/instrumentPositionSelectors");
var _decimalPlacesHelper = require("../../../../helpers/decimalPlaces/decimalPlacesHelper");
var _productPositionSelectors = require("../../../../redux/selectors/productPositionSelectors.js");
var _config = _interopRequireDefault(require("../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;
  var buySellForm = form.buySell || {
    values: {
      fee: {}
    }
  };
  var selectedValue = (0, _buySellSelectors.getOrderFormInfoSelector)(state);
  var price = selectedValue.price ? selectedValue.price : 0;
  var quantity = selectedValue.quantity ? selectedValue.quantity : '';
  var pricePerUnit = selectedValue.pricePerUnit ? selectedValue.pricePerUnit : 0;
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var Product2Symbol = selectedInstrument.Product2Symbol,
    Product1 = selectedInstrument.Product1,
    Product2 = selectedInstrument.Product2,
    PriceIncrement = selectedInstrument.PriceIncrement,
    QuantityIncrement = selectedInstrument.QuantityIncrement;
  var isBuySide = (0, _buySellSelectors.isBuySideBuySellFormSelector)(state);
  var finalQuantityProduct = isBuySide ? Product1 : Product2;
  var finalQuantity = isBuySide ? quantity : price;
  if (finalQuantityProduct === buySellForm.values.fee.ProductId) {
    finalQuantity -= buySellForm.values.fee.OrderFee;
  }
  return {
    isBuySide: isBuySide,
    products: (0, _productPositionSelectors.productsSelector)(state),
    buySellForm: buySellForm,
    selectedInstrument: selectedInstrument,
    price: price,
    quantity: quantity,
    pricePerUnit: (0, _orderHelper.getOrderPricePerUnit)(pricePerUnit, Product2Symbol, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(PriceIncrement)),
    finalQuantity: (0, _numberFormatter.truncateToDecimals)(finalQuantity, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(isBuySide ? QuantityIncrement : PriceIncrement)),
    hideFees: !!_config["default"].global.hideFees,
    displayPricePerUnit: _config["default"].RetailBuySell.pricePerUnit
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    confirmReport: function confirmReport(form) {
      return dispatch((0, _orderEntryActions.placeOrder)(_orderFormTypes.orderFormTypes.buySell, form)).then(function (res) {
        if (res.result === false) {
          dispatch((0, _snackbarActions.showSnack)({
            id: 'confirmBuySellFail',
            text: res.errormsg || res.detail,
            type: 'warning'
          }));
        }
      });
    },
    onClose: function onClose() {
      return dispatch((0, _orderEntryActions.clearBuySellForm)());
    }
  };
};
var container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BuySellConfirmationModalComponent["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.RETAIL_SUBMIT_ORDER
})(container);